import styled from 'styled-components';

export const SiteHeader = styled.header`
  margin: 0 auto;
  padding: 1em 0;
  text-align: left;
  background: #ffffff;

  h1, h2 {
    font-family: 'Open Sans',Calibri,Arial,sans-serif;
    text-transform: uppercase;
    font-size: 15px;
    transition: .5s;
    text-shadow: 1px 1px 1px #e2e0e0;
  }

  h1 {
    transform: scale(1.14,1.0);
    letter-spacing: 5px;
    margin: 0 0 13px 31px;

    @media (max-width: 767px) {
      margin-left: 0;
    }
  }

  h2 {
    letter-spacing: 5px;
    font-size: 14px;
    margin: 0 1px 0 17.5px;

    @media (max-width: 767px) {
      margin-left: 0;
    }
  }
`;

export const SiteLogoWrapper = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 992px) {
    flex-direction: column;
    text-align: center;
  }
`;

export const SiteLogo = styled.img`
  width: 120px;
  height: 120px;

  transition: .5s;

  @media (max-width: 992px) {
    width:75px;
    height:75px;
  }
`;

export const Navigation = styled.nav`
  font-family: 'Open Sans', Calibri, Arial, sans-serif;
  font-size: 1em;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  align-self: flex-end;

  a {
    display: inline-block;
    position: relative;
  	margin: 0 0 0 25px;
  	padding: 0 0 0.7em 0;
  	border-bottom: 3px solid #ffffff;
  	color: #38846c;
  	font-weight: 700;
    letter-spacing: 2px;

    transition: .5s;
  }

  a:before {
    content: '';
    position: absolute;
    top: 10px;
    left: 0;
    background: #221f1f;
    width: 100%;
    height: 2px;
    -webkit-transform: translateY(24px);
    transform: translateY(24px);
    opacity: 0;
    transition: .3s ease;
  }

  a:hover:before,
  a.current-item:before {
    -webkit-transform: translateY(18px);
    transform: translateY(18px);
    opacity: 1;
  }

  a:hover,
  a.current-item,
  a.current-item:hover {
  	color: #221f1f;
  }

  @media (max-width: 992px) {
    display: none;
  }
`;

export const MobileNavigationToggle = styled.a`
  text-align: center;
  position: fixed;
  top: 0;
  left: 0px;
  width: 70px;
  height: 70px;
  z-index: 11;
  display: none;
  cursor: pointer;

  @media (max-width: 992px) {
    display: block;
  }
`;

export const ToggleBurger = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 30px;
  display: block;
  margin-left: -15px;
  width: 30px;
  height: 3px;
  background: ${props => props.active ? 'rgba(220, 151, 31,0)' : '#333333'};

  :after, :before {
    content: '';
    position: absolute;
    width: 100%;
    height: 3px;
    background: #333333;
    left: 0;
    -webkit-transform-origin: center center;
    -moz-transform-origin: center center;
    -ms-transform-origin: center center;
    -o-transform-origin: center center;
    transform-origin: center center;
  }

  :before {
    top: -8px;
    transform: ${props => props.active ? 'rotate(45deg) translate(3px,8px)' : ''};
  }

  :after {
    bottom: -8px;
    transform: ${props => props.active ? 'rotate(-45deg) translate(3px,-8px)' : ''};
  }

  -webkit-transition: all 0.3s cubic-bezier(0.585, -0.600, 0.430, 1.650);
  -moz-transition: all 0.3s cubic-bezier(0.585, -0.600, 0.430, 1.650);
  -ms-transition: all 0.3s cubic-bezier(0.585, -0.600, 0.430, 1.650);
  -o-transition: all 0.3s cubic-bezier(0.585, -0.600, 0.430, 1.650);
  transition: all 0.3s cubic-bezier(0.585, -0.600, 0.430, 1.650);

  :before, :after {
    -webkit-transition: all 0.3s cubic-bezier(0.585, -0.600, 0.430, 1.650);
    -moz-transition: all 0.3s cubic-bezier(0.585, -0.600, 0.430, 1.650);
    -ms-transition: all 0.3s cubic-bezier(0.585, -0.600, 0.430, 1.650);
    -o-transition: all 0.3s cubic-bezier(0.585, -0.600, 0.430, 1.650);
    transition: all 0.3s cubic-bezier(0.585, -0.600, 0.430, 1.650);
  }
`;

export const MobileNavigation = styled.nav`
  position: absolute;
  top: 164px;
  left: 0;
  width: 90%;
  background: #ffffff;
  z-index: 5;
  overflow-y: scroll;
  margin: 0 3%;
  padding: 14px 2%;

  a {
    color: #333;
    display: block;
    border-bottom: 1px solid #ccc;
    padding: 12px 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Header.style.js